import React from 'react';

import * as S from './styles';

export const CustomStatusTag = ({ status }) => (
    <S.CustomStatusTagContainer id={status.codigo}>{status.descricao}</S.CustomStatusTagContainer>
);
